// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"510":"02251097","577":"07234cda","989":"02251097"}[chunkId] + ".css";
};